import { theme } from '@features/lci-report/domain/theme';
import { contentSlideHeader } from '@features/lci-report/utils';
import {
  Slide,
  barGrowth,
  creditCardOutline,
  handHoldingPhone,
  iconInCircle,
  parseTags,
} from '@features/powerpoint';
import { TITLE } from '../shared/dark-background-slide-master';
import { headerWithCaption } from './how-we-do-it/text';

type HowWeDoItSlideProps = {
  toplineText: string;
  conversionText: string;
  attributionText: string;
};

export const howWeDoItSlide = (props: HowWeDoItSlideProps): Slide => {
  return {
    slideMaster: TITLE,
    texts: [
      contentSlideHeader('LCI - How we do it', { color: theme.colors.white }),
      {
        text: parseTags(props.toplineText),
        options: {
          fontSize: 14,
          h: 0.78,
          w: 8.84,
          x: 2.23,
          y: 1.82,
          align: 'center',
          color: theme.colors.white,
        },
      },
      headerWithCaption('Exposure', 'Audience is exposed to a campaign', {
        x: 2.06,
      }),
      headerWithCaption('Conversion', props.conversionText, {
        x: 5.32,
        w: 3.07,
      }),
      headerWithCaption('Attribution', props.attributionText, {
        x: 8.68,
        w: 3.45,
      }),
    ],
    images: [
      ...iconInCircle(handHoldingPhone, { x: 2.55, y: 3 }).images,
      ...iconInCircle(
        creditCardOutline,
        { x: 6.1, y: 3 },
        { h: 1, w: 1, x: 6.36, y: 3.25 }
      ).images,
      ...iconInCircle(
        barGrowth,
        { x: 9.66, y: 3 },
        { h: 0.68, w: 0.68, x: 10.07, y: 3.41 }
      ).images,
    ],
  };
};
